import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { AvatarLetter, Menu, IconButton, AvatarWithLabel } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Link } from 'react-router-dom';
import { useAccount, useAccounts, SSORestricted, activeAccount } from 'shared/domains/users';
export function CompanySelector() {
    var _a;
    const account = useAccount();
    const accounts = useAccounts();
    const activeCompany = (_a = account.data) === null || _a === void 0 ? void 0 : _a.companyId;
    const filteredAccounts = accounts;
    const handleSelectAccount = (selection) => {
        const { id, company } = selection;
        const { marketCode } = company;
        activeAccount.set(id);
        // eslint-disable-next-line react-compiler/react-compiler
        window.location.href = `${window.location.origin}/${marketCode}`;
    };
    return (<Fragment>
      <Menu.Label action={<SSORestricted>
            <Link to="/add-company">
              <IconButton size="xs" appearance="secondary" aria-label={t({ message: 'Add company', comment: 'User menu: add company button' })}>
                <Falcon icon="plus"/>
              </IconButton>
            </Link>
          </SSORestricted>}>
        <Trans comment="User menu: my companies list header text">My companies</Trans>
      </Menu.Label>
      {filteredAccounts.map(({ id, company }) => (<Menu.Item key={id} selected={activeCompany === company.id} onClick={() => handleSelectAccount({ id, company })}>
          <AvatarWithLabel size="sm" appearance="light" title={company.name}>
            <AvatarLetter>{company.name[0]}</AvatarLetter>
          </AvatarWithLabel>
        </Menu.Item>))}
    </Fragment>);
}
